import { tv } from "@/utils/tv.config";

import { VariantProps } from "tailwind-variants";

export const timelineClasses = tv({
  base: [
    "Timeline__root",
    "space-y-8",
    "relative",
    "before:absolute",
    "before:inset-0",
    "before:ml-4",
    "before:-translate-x-px",
    "md:before:mx-auto",
    "md:before:translate-x-0",
    "before:h-full",
    "before:w-px",
    "before:h-[calc(100%-115px)]",
    "before:my-auto",
    "counter-reset",
  ],
  variants: {
    orientation: {
      horizontal: "",
      vertical: "",
    },
    variant: {
      solid: ["before:bg-gray-200"],
      gradient: [
        "before:bg-gradient-to-b",
        "before:from-gray-200",
        "before:via-gray-300",
        "before:to-gray-200",
      ],
      connected: [""],
    },
  },
  defaultVariants: {
    variant: "solid",
  },
});

export type TimelineVariantProps = VariantProps<typeof timelineClasses>;
